import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { success, slate, coal } from './colors';
import Tooltip from './Tooltip';
import { mapBsStyleToColor } from './utils';
var pseudobold = "0 0 .65px ".concat(coal, ", 0 0 .65px ").concat(coal);

var StepCircle = function StepCircle(_ref) {
  var size = _ref.size,
      borderWidth = _ref.borderWidth,
      color = _ref.color,
      filled = _ref.filled;
  return React.createElement("div", {
    value: "step-circle",
    style: {
      flexShrink: 0,
      width: "".concat(size, "px"),
      height: "".concat(size, "px"),
      border: "".concat(borderWidth, "px solid ").concat(color),
      borderRadius: '100%',
      backgroundColor: filled ? color : 'white'
    }
  });
};

StepCircle.propTypes = {
  size: PropTypes.number.isRequired,
  borderWidth: PropTypes.number.isRequired,
  color: PropTypes.string.isRequired,
  filled: PropTypes.bool
};

var StepHalfCircle = function StepHalfCircle(_ref2) {
  var size = _ref2.size,
      color = _ref2.color;
  return React.createElement("div", {
    style: {
      flexShrink: 0,
      width: "".concat(size, "px"),
      height: "".concat(size, "px"),
      borderRadius: '50%',
      border: "2px solid ".concat(color),
      overflow: 'hidden'
    }
  }, React.createElement("div", {
    style: {
      display: 'inline-block',
      backgroundColor: color,
      height: "".concat(size, "px"),
      width: "".concat(size / 2 - 2, "px")
    }
  }), React.createElement("div", {
    style: {
      display: 'inline-block',
      backgroundColor: 'white',
      height: "".concat(size, "px"),
      width: "".concat(size / 2 - 2, "px")
    }
  }));
};

StepHalfCircle.propTypes = {
  size: PropTypes.number.isRequired,
  color: PropTypes.string.isRequired
};

var Step =
/*#__PURE__*/
function (_Component) {
  _inherits(Step, _Component);

  function Step() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Step);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Step)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "handleClick", function () {
      if (!_this.props.onClick) {
        return;
      }

      _this.props.onClick(_this.props.index, _this.props.name);
    });

    return _this;
  }

  _createClass(Step, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          active = _this$props.active,
          activeColor = _this$props.activeColor,
          overrideBsStyle = _this$props.overrideBsStyle,
          completed = _this$props.completed,
          onClick = _this$props.onClick,
          tip = _this$props.tip,
          tipDirection = _this$props.tipDirection,
          small = _this$props.small,
          partial = _this$props.partial,
          icon = _this$props.icon,
          children = _this$props.children,
          vertical = _this$props.vertical;
      var color = slate;
      var filled = completed;
      var size = small ? 14 : 20;

      if (overrideBsStyle) {
        color = mapBsStyleToColor(overrideBsStyle, {
          fallback: slate
        });
      } else if (completed) {
        color = success.base;
      } else if (active) {
        color = activeColor;
      }

      var indicatorIcon = React.createElement(StepCircle, {
        color: color,
        borderWidth: active ? small ? 4 : 6 : 2,
        size: size,
        filled: filled
      });

      if (icon && !small) {
        indicatorIcon = React.createElement("div", {
          style: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            height: "".concat(size, "px"),
            width: "".concat(size, "px"),
            background: color,
            color: 'white',
            borderRadius: '100%'
          }
        }, icon);
      } else if (partial) {
        indicatorIcon = React.createElement(StepHalfCircle, {
          color: color,
          size: size
        });
      }

      var stepperStyle;
      var indicatorStyle;
      var childrenStyle;

      if (vertical) {
        stepperStyle = {
          textAlign: 'center',
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center'
        };
        indicatorStyle = {
          display: 'flex',
          justifyContent: 'center'
        };
        childrenStyle = {
          padding: '7px 0',
          marginLeft: '10px',
          textShadow: active ? pseudobold : 'none'
        };
      } else {
        stepperStyle = {
          padding: small ? '0 4px' : '0 14px',
          textAlign: 'center'
        };
        indicatorStyle = {
          display: 'flex',
          justifyContent: 'center',
          paddingBottom: children ? '0' : '14px'
        };
        childrenStyle = {
          padding: '14px 0',
          textShadow: active ? pseudobold : 'none'
        };
      }

      var step = // TODO define stepper styles properly and move to stylesheet
      React.createElement("div", {
        className: "stepper-step ".concat(onClick ? 'clickable' : ''),
        style: stepperStyle,
        onClick: this.handleClick
      }, React.createElement("div", {
        style: indicatorStyle
      }, indicatorIcon), children && (!small || vertical) ? React.createElement("div", {
        style: childrenStyle
      }, children) : null);
      return tip ? React.createElement(Tooltip, {
        direction: tipDirection,
        contents: tip
      }, step) : step;
    }
  }]);

  return Step;
}(Component);

export { Step as default };
Step.propTypes = {
  index: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  active: PropTypes.bool,
  partial: PropTypes.bool,
  activeColor: PropTypes.string,
  overrideBsStyle: PropTypes.oneOf(['success', 'none', 'warning', 'danger']),
  completed: PropTypes.bool,
  onClick: PropTypes.func,
  name: PropTypes.string,
  tip: PropTypes.node,
  tipDirection: PropTypes.oneOf(['top', 'right', 'bottom', 'left']),
  children: PropTypes.node,
  small: PropTypes.bool,
  icon: PropTypes.node,
  vertical: PropTypes.bool
};
Step.defaultProps = {
  tipDirection: 'top'
};